export default "__VITE_ASSET__905ac50b__"